import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门吃瓜合集
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            按主题分类聚合热门内容，快速找到你感兴趣的吃瓜专题
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#updates"
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-200 cursor-pointer no-underline"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-lg text-accent-500`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-medium text-foreground-800 truncate">
                    {item.title}
                  </h3>
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <span className="text-xs text-foreground-400">{item.count}</span>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}